"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defaultAppData = _interopRequireDefault(require("./defaultAppData"));
var _schema = _interopRequireDefault(require("default-app/dist/common/schema"));
var _excluded = ["props"];
function _default(_ref) {
  var data = _ref.data;
  var generateLabelForArrayItems = function generateLabelForArrayItems(_ref2) {
    var props = _ref2.props;
    var value = props.value,
      propertyKey = props.propertyKey;
    if (value && value.name && Object.keys(value.name)[0]) {
      var key = value.key || propertyKey;
      return value.name[Object.keys(value.name)[0]] + " [" + key + "]";
    }
    return propertyKey.slice ? propertyKey.slice(0, 1).toUpperCase() + propertyKey.slice(1) : propertyKey.toString();
  };
  var subscribePropertiesForLabelForArrayItems = function subscribePropertiesForLabelForArrayItems(_ref3) {
    var _rootData$settings, _rootData$settings$ba;
    var schemaFormContext = _ref3.schemaFormContext,
      props = _ref3.props,
      setLabel = _ref3.setLabel;
    var stateManager = schemaFormContext.stateManager,
      rootData = schemaFormContext.rootData;
    var propertyTreeString = props.propertyTreeString,
      value = props.value,
      propertyKey = props.propertyKey;
    var languages = ((_rootData$settings = rootData.settings) === null || _rootData$settings === void 0 ? void 0 : (_rootData$settings$ba = _rootData$settings.basic_settings) === null || _rootData$settings$ba === void 0 ? void 0 : _rootData$settings$ba.languages) || ["lang_1"];
    return stateManager.subscribe( /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(state, _ref4) {
        var type, payload, changingItemPropertyTreeString, key;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = _ref4.type, payload = _ref4.payload;
              if (!(type === "SET_LABEL")) {
                _context.next = 7;
                break;
              }
              changingItemPropertyTreeString = payload.name;
              if (!(changingItemPropertyTreeString === propertyTreeString + ".name." + languages[0])) {
                _context.next = 7;
                break;
              }
              key = value.key || propertyKey;
              _context.next = 7;
              return setLabel(payload.value + " [" + key + "]");
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref5.apply(this, arguments);
      };
    }());
  };
  function updateEditor(_x3) {
    return _updateEditor.apply(this, arguments);
  }
  function _updateEditor() {
    _updateEditor = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee19(p) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return p.schemaFormContext.props.additionalProperties.updateEditor(p);
          case 2:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _updateEditor.apply(this, arguments);
  }
  return (0, _objectSpread2["default"])({}, (0, _schema["default"])({
    data: data,
    properties: {
      renderProps: {
        schemaType: "Object",
        properties: {
          viewBox: {
            schemaType: "Object",
            properties: {
              startX: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  function onBlur(_x4) {
                    return _onBlur.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              startY: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function onBlur(_x5) {
                    return _onBlur2.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              width: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  function onBlur(_x6) {
                    return _onBlur3.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              height: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  function onBlur(_x7) {
                    return _onBlur4.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          }
        }
      },
      compositions: {
        schemaType: "Array",
        add: function () {
          var _add = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(p) {
            var props, setValue, _props$value, value;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  props = p.props;
                  setValue = props.setValue, _props$value = props.value, value = _props$value === void 0 ? [] : _props$value;
                  value.push((0, _objectSpread2["default"])({}, JSON.parse(JSON.stringify(_defaultAppData["default"].compositions[0]))));
                  _context6.next = 5;
                  return setValue(value, true);
                case 5:
                  _context6.next = 7;
                  return updateEditor(p);
                case 7:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function add(_x8) {
            return _add.apply(this, arguments);
          }
          return add;
        }(),
        items: {
          schemaType: "Object",
          generateLabel: generateLabelForArrayItems,
          useEffectForLabel: subscribePropertiesForLabelForArrayItems,
          enableDelete: true,
          onDelete: function () {
            var _onDelete = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            function onDelete(_x9) {
              return _onDelete.apply(this, arguments);
            }
            return onDelete;
          }(),
          properties: {
            data: {
              schemaType: "Array",
              add: function () {
                var _add2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(_ref6) {
                  var props, rest, setValue, _props$value2, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        props = _ref6.props, rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
                        setValue = props.setValue, _props$value2 = props.value, value = _props$value2 === void 0 ? [] : _props$value2;
                        value.push({
                          width: 6,
                          height: 0.9,
                          depth: 9,
                          material: {
                            color: 0xe7b508,
                            opacity: 0.95
                          },
                          position: {
                            x: -10,
                            y: 0,
                            z: 0.12
                          }
                        });
                        _context8.next = 5;
                        return setValue(value, true);
                      case 5:
                        _context8.next = 7;
                        return updateEditor((0, _objectSpread2["default"])({
                          props: props
                        }, rest));
                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                function add(_x10) {
                  return _add2.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "Object",
                generateLabel: generateLabelForArrayItems,
                useEffectForLabel: subscribePropertiesForLabelForArrayItems,
                enableDelete: function enableDelete(_ref7) {
                  var props = _ref7.props;
                  return props.parentValue && props.parentValue.length ? props.propertyKey && props.propertyKey > 0 : false;
                },
                onDelete: function () {
                  var _onDelete2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  }));
                  function onDelete(_x11) {
                    return _onDelete2.apply(this, arguments);
                  }
                  return onDelete;
                }(),
                properties: {
                  geometryType: {
                    schemaType: "String",
                    onBlur: function () {
                      var _onBlur5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                          while (1) switch (_context10.prev = _context10.next) {
                            case 0:
                              _context10.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context10.stop();
                          }
                        }, _callee10);
                      }));
                      function onBlur(_x12) {
                        return _onBlur5.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  width: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
                          while (1) switch (_context11.prev = _context11.next) {
                            case 0:
                              _context11.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context11.stop();
                          }
                        }, _callee11);
                      }));
                      function onBlur(_x13) {
                        return _onBlur6.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  height: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
                          while (1) switch (_context12.prev = _context12.next) {
                            case 0:
                              _context12.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context12.stop();
                          }
                        }, _callee12);
                      }));
                      function onBlur(_x14) {
                        return _onBlur7.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  material: {
                    schemaType: "Object",
                    properties: {
                      color: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
                              while (1) switch (_context13.prev = _context13.next) {
                                case 0:
                                  _context13.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context13.stop();
                              }
                            }, _callee13);
                          }));
                          function onBlur(_x15) {
                            return _onBlur8.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      opacity: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                              while (1) switch (_context14.prev = _context14.next) {
                                case 0:
                                  _context14.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context14.stop();
                              }
                            }, _callee14);
                          }));
                          function onBlur(_x16) {
                            return _onBlur9.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  position: {
                    schemaType: "Object",
                    properties: {
                      x: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
                              while (1) switch (_context15.prev = _context15.next) {
                                case 0:
                                  _context15.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context15.stop();
                              }
                            }, _callee15);
                          }));
                          function onBlur(_x17) {
                            return _onBlur10.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      y: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
                              while (1) switch (_context16.prev = _context16.next) {
                                case 0:
                                  _context16.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context16.stop();
                              }
                            }, _callee16);
                          }));
                          function onBlur(_x18) {
                            return _onBlur11.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  }
                }
              }
            },
            background: {
              schemaType: "String",
              onBlur: function () {
                var _onBlur12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17(p) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.next = 2;
                        return updateEditor(p);
                      case 2:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                function onBlur(_x19) {
                  return _onBlur12.apply(this, arguments);
                }
                return onBlur;
              }()
            },
            animation: {
              schemaType: "Array",
              add: function () {
                var _add3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18(_ref8) {
                  var props, setValue, _props$value3, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
                    while (1) switch (_context18.prev = _context18.next) {
                      case 0:
                        props = _ref8.props;
                        setValue = props.setValue, _props$value3 = props.value, value = _props$value3 === void 0 ? [] : _props$value3;
                        value.push("");
                        _context18.next = 5;
                        return setValue(value, true);
                      case 5:
                      case "end":
                        return _context18.stop();
                    }
                  }, _callee18);
                }));
                function add(_x20) {
                  return _add3.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "String",
                enableDelete: true
              }
            }
          }
        }
      }
    }
  }));
}